/**
 * Whether the Nutrition V2 rewrite is offered in the UI.
 *
 * It gates the two ENTRY POINTS only: the "תזונה V2" button on the old nutrition page
 * and the "ספריית תזונה V2" side-nav entry. The routes themselves are always registered,
 * so `/app/clients/:userId/nutrition-v2` works either way: while this is `false` V2 is
 * out of the trainers' way, without being taken away from anyone testing it by URL.
 *
 * Currently ON, so the entry points are visible without having to know the URL. Note what
 * that means once this branch is deployed: every trainer sees V2, and V2 still keeps its
 * menus in `localStorage` rather than on a server (see docs/NUTRITION_V2_HANDOFF.md §1).
 * Set it back to `false` before shipping if the server work has not landed by then.
 */
export const NUTRITION_V2_ENABLED = true;
